export const RecalProcessAndGenConstant = {
    TITLE: "Recalculation Processing & Generation",
    SEARCH_CRITERIA: "Search Criteria",
    CO_VSL_VOY: 'Co/Vsl/Voy',
    OPS_DATE_RANGE: "Ops Date Range",
    DOC_DATE_RANGE: "Doc. Date Range",
    DEP_DATE_RANGE: "Dep Date Range",
    SEQ_NO: "Seq No.",
    SEQ_NO_FROM: "Sequence No. (From)",
    SEQ_NO_TO: "Sequence No. (To)",
    DOC_NO: "Doc. No.",
    DOC_NO_FROM: "Doc No. (From)",
    DOC_NO_TO: "Doc No. (To)",
    MANUAL_CHARGE_NO: "Manual Charge No.",
    CREDIT_CHARGE_NO: "Credit Charge No.",
    GROUP_NO: "Group No.",
    STATE: "State",
    ADJ_IND: "Adj. Ind.",
    RECAL_SET_IND: "Recal Set Ind.",
    MERGE_DIFF_BAL: "Merge Diff Bal.",
    BILLTO_COMPANY: "Bill-To Company",
    NTN_NO: "NTN No.",
    CHARGEON_COMPANY: "Charge-On Company",
    CUSTOMER_CODE: "Customer Code",
    OPS_DATE: "Ops Date",
    DOC_DATE: "Doc. Date",
    CONSORTIUM_CODE: "Consortium Code",
    VESSEL_CODE: "Vessel Code",
    VOYAGE_CODE: "Voyage Code",
    DEP_DATETIME: "Dep Date/Time",
    CHARGE_TYPE: "Charge Type",
    SUB_CHARGE_TYPE: "Sub Charge Type",
    TARIFF_TYPE: "Tariff Type",
    TARIFF_CODE: "Tariff Code",
    TAR_DESC: "Tar Desc",
    CHARGE_QTY: "Charge Qty",
    INDIVIDUAL_CHARGE_QTY: "Individual Charge Qty",
    ORIGINAL_ONEOFF_RATE: "Original One-off Rate",
    ORIGINAL_AMOUNT: "Original Amount",
    NEW_ONEOFF_RATE: "New One-off Rate",
    ONEOFF_RATE: "One-off Rate",
    NEW_AMOUNT: "New Amount",
    BAL_DIFF: "Bal. Diff.",
    BAL_DIFFAMOUNT: "Bal. Diff.(Amount)",
    BAL_DIFFTAX: "Bal. Diff.(Tax)",
    REVENUE_COMPANY_CODE: "Revenue Company Code",
    REVENUE_AC_CODE: "Revenue A/C Code",
    COST_CENTER_CODE: "Cost Center Code",
    PRODUCT_SERVICE_CODE: "Product Service Code",
    SALES_CHANNEL_CODE: "Sales Channel Code",
    COUNTRY_CODE: "Country Code",
    INTERCOMPANY_CODE: "Inter-company Code",
    PROJECT_CODE: "Project Code",
    SPARE_CODE: "Spare Code",
    ORIGINAL_TAX_AMOUNT: "Original Tax Amount",
    NEW_TAX_AMOUNT: "New Tax Amount",
    TAX_REVENUE_COMPANY_CODE: "Tax Revenue Company Code",
    TAX_REVENUE_AC_CODE: "Tax Revenue A/C Code",
    TAX_COST_CENTER_CODE: "Tax Cost Center Code",
    TAX_PRODUCT_SERVICE_CODE: "Tax Product Service Code",
    TAX_SALES_CHANNEL_CODE: "Tax Sales Channel Code",
    TAX_COUNTRY_CODE: "Tax Country Code",
    TAX_INTERCOMPANY_CODE: "Tax Inter-company Code",
    TAX_PROJECT_CODE: "Tax Project Code",
    TAX_SPARE_CODE: "Tax Spare Code",
    REMARKS: "Remarks",
    EXCEPTION_MSG: "Exception Msg",
    DESC1: "Description 1",
    DESC2: "Description 2",
    OLD_TARIFF: "Old Tariff",
    NEW_TARIFF: "New Tariff",
    REVENUE_ACCOUNT_CODE: "Revenue Account Code",
    PRODUCT_OR_SERVICE_CODE: "Product/Service Code",
    DISCOUNT_TYPE: "Discount Type",
    DISCOUNT_PERCENT: "Discount Percent",
    ORIGINAL_DISCOUNT_AMOUNT: "Original Discount Amount",
    NEW_DISCOUNT_AMOUNT: "New Discount Amount",
    DISCOUNT_REVENUE_COMPANY_CODE: "Discount Revenue Company Code",
    DISCOUNT_REVENUE_AC_CODE: "Discount Revenue A/C Code",
    DISCOUNT_COST_CENTER_CODE: "Discount Cost Center Code",
    DISCOUNT_PRODUCT_SERVICE_CODE: "Discount Product Service Code",
    DISCOUNT_SALES_CHANNEL_CODE: "Discount Sales Channel Code",
    DISCOUNT_COUNTRY_CODE: "Discount Country Code",
    DISCOUNT_INTER_COMPANY_CODE: "Discount Inter-company Code",
    DISCOUNT_PROJECT_CODE: "Discount Project Code",
    DISCOUNT_SPARE_CODE: "Discount Spare Code",
    ORIGINAL_DISCOUNT_TAX_AMOUNT: "Original Discount Tax Amount",
    NEW_DISCOUNT_TAX_AMOUNT: "New Discount Tax Amount",
    DISCOUNT_TAX_REVENUE_COMPANY_CODE: "Discount Tax Revenue Company Code",
    DISCOUNT_TAX_REVENUE_AC_CODE: "Discount Tax Revenue A/C Code",
    DISCOUNT_TAX_COST_CENTER_CODE: "Discount Tax Cost Center Code",
    DISCOUNT_TAX_PRODUCT_SERVICE_CODE: "Discount Tax Product Service Code",
    DISCOUNT_TAX_SALES_CHANNEL_CODE: "Discount Tax Sales Channel Code",
    DISCOUNT_TAX_COUNTRY_CODE: "Discount Tax Country Code",
    DISCOUNT_TAX_INTER_COMPANY_CODE: "Discount Tax Inter-company Code",
    DISCOUNT_TAX_PROJECT_CODE: "Discount Tax Project Code",
    DISCOUNT_TAX_SPARE_CODE: "Discount Tax Spare Code",
}